// Texty sekce hodnocení — slovenské dvojče locale/cs/reviews.js.
// SK ukazuje hodnocení téže firmy (Heureka.cz, Google) s čísly z manifestu;
// tenant `jipos-sk` recenze nemá (U6), takže citace jsou záloha z manifestu.
export default {
  eyebrow: 'Overené zákazníkmi',
  max: '/5',
  ctaLabel: 'Všetky hodnotenia',
  countSuffix: 'hodnotení',
  customersLabel: 'zákazníkov',
  platMax: '/ 5',
  percent: '%',
  sourceMulti: 'Spočítané naprieč platformami: ',
  sourceSingle: 'Hodnotenie obchodu · ',
  converted: (names, example) =>
    (names.length > 1
      ? names.slice(0, -1).join(', ') + ' a ' + names[names.length - 1] + ' uvádzajú'
      : names[0] + ' uvádza') +
    ' percento spokojných zákazníkov, do súhrnu ho prevádzame na hviezdičky (' + example + ').',
  convertedExample: (pct, stars) => pct + '\u00A0% = ' + stars,
  poolNote: (name) => 'zdieľa hodnotenia so ' + name,
  ownNote: 'hodnotenia priamo na našom webe',
  platformAria: (name, score, count) => name + ': ' + score + ', ' + count,
  ariaPercent: (n) => n + '\u00A0%',
  ariaStars: (value) => value + ' z 5',
  quotesTitle: {
    obecne: 'Čo o nás píšu zákazníci',
    doprava: 'Čo zákazníci píšu o doručení',
    reklamace: 'Čo zákazníci píšu o reklamáciách a vrátení tovaru',
    komunikace: 'Čo zákazníci píšu o komunikácii s nami',
  },
  categoryTitle: (name) => 'Recenzie produktov z kategórie ' + name,
  verify: 'Ako recenzie overujeme',
  sourceHeureka: 'Overené Heurekou',
  sourceWeb: (shop) => 'Recenzia na ' + shop,
  starsAria: (n) => n + ' z 5 hviezdičiek',
};
